import React from 'react';
import { VStack, Text } from '@chakra-ui/react';
import HeroSection from '../components/common/HeroSection';
import Content from '../components/autism/Content';
import MiniNavbar from '../components/common/MiniNavbar'; 
const Autism = () => {
    return (
        <VStack spacing={0}>
            <HeroSection />
            {/* <JoinCommunity from={"autism"}/> */}
            <MiniNavbar /> 
            <Content />
        </VStack>
    );
};

export default Autism;
